{
  "black": "#000000",
  "white": "#fff",
  "slate": {
    "50": "#f8fafc",
    "100": "#f1f5f9",
    "200": "#e2e8f0",
    "300": "#cbd5e1",
    "400": "#94a3b8",
    "500": "#64748b",
    "600": "#475569",
    "700": "#334155",
    "800": "#1e293b",
    "900": "#0f172a",
    "950": "#020617"
  },
  "gray": {
    "50": "#f9fafb",
    "100": "#f3f4f6",
    "200": "#e5e7eb",
    "300": "#d1d5db",
    "400": "#9ca3af",
    "500": "#6b7280",
    "600": "#4b5563",
    "700": "#374151",
    "800": "#1f2937",
    "900": "#111827",
    "950": "#030712"
  },
  "zinc": {
    "50": "#fafafa",
    "100": "#f4f4f5",
    "200": "#e4e4e7",
    "300": "#d4d4d8",
    "400": "#a1a1aa",
    "500": "#71717a",
    "600": "#52525b",
    "700": "#3f3f46",
    "800": "#27272a",
    "900": "#18181b",
    "950": "#09090b"
  },
  "neutral": {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#e5e5e5",
    "300": "#d4d4d4",
    "400": "#a3a3a3",
    "500": "#737373",
    "600": "#525252",
    "700": "#404040",
    "800": "#262626",
    "900": "#171717",
    "950": "#0a0a0a"
  },
  "stone": {
    "50": "#fafaf9",
    "100": "#f5f5f4",
    "200": "#e7e5e4",
    "300": "#d6d3d1",
    "400": "#a8a29e",
    "500": "#78716c",
    "600": "#57534e",
    "700": "#44403c",
    "800": "#292524",
    "900": "#1c1917",
    "950": "#0c0a09"
  },
  "orange": {
    "50": "#fff7ed",
    "100": "#ffedd5",
    "200": "#fed7aa",
    "300": "#fdba74",
    "400": "#fb923c",
    "500": "#f97316",
    "600": "#ea580c",
    "700": "#c2410c",
    "800": "#9a3412",
    "900": "#7c2d12",
    "950": "#431407"
  },
  "amber": {
    "50": "#fffbeb",
    "100": "#fef3c7",
    "200": "#fde68a",
    "300": "#fcd34d",
    "400": "#fbbf24",
    "500": "#f59e0b",
    "600": "#d97706",
    "700": "#b45309",
    "800": "#92400e",
    "900": "#78350f",
    "950": "#451a03"
  },
  "lime": {
    "50": "#f7fee7",
    "100": "#ecfccb",
    "200": "#d9f99d",
    "300": "#bef264",
    "400": "#a3e635",
    "500": "#84cc16",
    "600": "#65a30d",
    "700": "#4d7c0f",
    "800": "#3f6212",
    "900": "#365314",
    "950": "#1a2e05"
  },
  "emerald": {
    "50": "#ecfdf5",
    "100": "#d1fae5",
    "200": "#a7f3d0",
    "300": "#6ee7b7",
    "400": "#34d399",
    "500": "#10b981",
    "600": "#059669",
    "700": "#047857",
    "800": "#065f46",
    "900": "#064e3b",
    "950": "#022c22"
  },
  "teal": {
    "50": "#f0fdfa",
    "100": "#ccfbf1",
    "200": "#99f6e4",
    "300": "#5eead4",
    "400": "#2dd4bf",
    "500": "#14b8a6",
    "600": "#0d9488",
    "700": "#0f766e",
    "800": "#115e59",
    "900": "#134e4a",
    "950": "#042f2e"
  },
  "cyan": {
    "50": "#ecfeff",
    "100": "#cffafe",
    "200": "#a5f3fc",
    "300": "#67e8f9",
    "400": "#22d3ee",
    "500": "#06b6d4",
    "600": "#0891b2",
    "700": "#0e7490",
    "800": "#155e75",
    "900": "#164e63",
    "950": "#083344"
  },
  "sky": {
    "50": "#f0f9ff",
    "100": "#e0f2fe",
    "200": "#bae6fd",
    "300": "#7dd3fc",
    "400": "#38bdf8",
    "500": "#0ea5e9",
    "600": "#0284c7",
    "700": "#0369a1",
    "800": "#075985",
    "900": "#0c4a6e",
    "950": "#082f49"
  },
  "blue": {
    "50": "#eff6ff",
    "100": "#dbeafe",
    "200": "#bfdbfe",
    "300": "#93c5fd",
    "400": "#60a5fa",
    "500": "#3b82f6",
    "600": "#2563eb",
    "700": "#1d4ed8",
    "800": "#1e40af",
    "900": "#1e3a8a",
    "950": "#172554"
  },
  "indigo": {
    "50": "#eef2ff",
    "100": "#e0e7ff",
    "200": "#c7d2fe",
    "300": "#a5b4fc",
    "400": "#818cf8",
    "500": "#6366f1",
    "600": "#4f46e5",
    "700": "#4338ca",
    "800": "#3730a3",
    "900": "#312e81",
    "950": "#1e1b4b"
  },
  "violet": {
    "50": "#f5f3ff",
    "100": "#ede9fe",
    "200": "#ddd6fe",
    "300": "#c4b5fd",
    "400": "#a78bfa",
    "500": "#8b5cf6",
    "600": "#7c3aed",
    "700": "#6d28d9",
    "800": "#5b21b6",
    "900": "#4c1d95",
    "950": "#2e1065"
  },
  "purple": {
    "50": "#faf5ff",
    "100": "#f3e8ff",
    "200": "#e9d5ff",
    "300": "#d8b4fe",
    "400": "#c084fc",
    "500": "#a855f7",
    "600": "#9333ea",
    "700": "#7e22ce",
    "800": "#6b21a8",
    "900": "#581c87",
    "950": "#3b0764"
  },
  "fuchsia": {
    "50": "#fdf4ff",
    "100": "#fae8ff",
    "200": "#f5d0fe",
    "300": "#f0abfc",
    "400": "#e879f9",
    "500": "#d946ef",
    "600": "#c026d3",
    "700": "#a21caf",
    "800": "#86198f",
    "900": "#701a75",
    "950": "#4a044e"
  },
  "pink": {
    "50": "#fdf2f8",
    "100": "#fce7f3",
    "200": "#fbcfe8",
    "300": "#f9a8d4",
    "400": "#f472b6",
    "500": "#ec4899",
    "600": "#db2777",
    "700": "#be185d",
    "800": "#9d174d",
    "900": "#831843",
    "950": "#500724"
  },
  "rose": {
    "50": "#fff1f2",
    "100": "#ffe4e6",
    "200": "#fecdd3",
    "300": "#fda4af",
    "400": "#fb7185",
    "500": "#f43f5e",
    "600": "#e11d48",
    "700": "#be123c",
    "800": "#9f1239",
    "900": "#881337",
    "950": "#4c0519"
  },
  "yellow": {
    "50": "#fcfbea",
    "100": "#f8f8c9",
    "200": "#f2ee96",
    "300": "#ede374",
    "400": "#e2cb2d",
    "500": "#d2b520",
    "600": "#b58f19",
    "700": "#916817",
    "800": "#78531b",
    "900": "#67461c",
    "950": "#3c250c"
  },
  "green": {
    "50": "#f6faf3",
    "100": "#ebf4e4",
    "200": "#d7e8ca",
    "300": "#b4d59e",
    "400": "#8cba6e",
    "500": "#6b9e49",
    "600": "#558138",
    "700": "#44662f",
    "800": "#385229",
    "900": "#2f4423",
    "950": "#16240f"
  },
  "dark-green": {
    "50": "#f4f9f7",
    "100": "#daede6",
    "200": "#b4dbcc",
    "300": "#87c1ae",
    "400": "#5ea38e",
    "500": "#448874",
    "600": "#356c5d",
    "700": "#2d584c",
    "800": "#294a42",
    "900": "#243d37",
    "950": "#11221f"
  },
  "anthracite": {
    "50": "#f7f7f6",
    "100": "#e5e4e2",
    "200": "#cac9c5",
    "300": "#a8a7a0",
    "400": "#85847c",
    "500": "#6a6a62",
    "600": "#54544d",
    "700": "#454540",
    "800": "#3a3935",
    "900": "#32322f",
    "950": "#22221f"
  },
  "warm-grey": {
    "50": "#f8f6f4",
    "100": "#eeeae5",
    "200": "#ddd5cb",
    "300": "#c7b9aa",
    "400": "#af9988",
    "500": "#9f8270",
    "600": "#927364",
    "700": "#7a5e54",
    "800": "#644f48",
    "900": "#52423c",
    "950": "#2b211f"
  },
  "light-blue": {
    "50": "#f6f8f9",
    "100": "#ebf0f3",
    "200": "#d3dde4",
    "300": "#beced8",
    "400": "#7f9fb1",
    "500": "#5f8298",
    "600": "#4b6a7e",
    "700": "#3d5567",
    "800": "#364956",
    "900": "#303e4a",
    "950": "#202931"
  },
  "red": {
    "50": "#FBE9E6",
    "100": "#F7D4CE",
    "200": "#F1BFB6",
    "300": "#EBA99E",
    "400": "#E49487",
    "500": "#DC7E70",
    "600": "#D46759",
    "700": "#C13327",
    "800": "#C13327",
    "900": "#B60000",
    "950": "#6F0000"
  },
  "brand": {
    "anthracite": "#22221f",
    "green": "#b4d59e",
    "warm-grey": "#eeeae5",
    "dark-green": "#294a42",
    "light-blue": "#beced8",
    "yellow": "#ede374"
  },
  "brands": {
    "oura": "#3284FF",
    "garmin": "#10A9ED",
    "whoop": "#101518",
    "yazio": "#e91f63",
    "myfitnesspal": "#0062F7",
    "withings": "#000000",
    "sponser": "#d0043c"
  }
}
